import {
  REQUEST_POST_MESSAGE,
  RECEIVE_POST_MESSAGE,
  HANDLE_POST_MESSAGE_ERROR,
  ADD_MUNICIPALITY_DATA,
  SHOW_FORM,
  UPDATE_TEXTAREA_LENGTH
} from '../actions/form'

function formReducer (state = null, action) {
  switch (action.type) {
    case UPDATE_TEXTAREA_LENGTH:
      return {
        ...state,
        textAreaLength: action.length
      }
    case REQUEST_POST_MESSAGE:
      return {
        ...state,
        submitted: true
      }
    case RECEIVE_POST_MESSAGE:
      return {
        ...state,
        receivedResult: true,
        result: action.result
      }
    case HANDLE_POST_MESSAGE_ERROR:
      return {
        ...state,
        submitError: true
      }
    case ADD_MUNICIPALITY_DATA:
      return {
        ...state,
        municipality: action.municipality
      }
    case SHOW_FORM:
      return {
        ...state,
        showForm: true
      }
    default:
      return state
  }
}

export default formReducer



// WEBPACK FOOTER //
// ./src/shared/reducers/form.js